export default (errorData) => {
  return {
    event: 'continue',
    type: errorData.type, // Error type
    statusCode: errorData.statusCode, // HTTP Status Code
    code: errorData.code, // Error code
    actionable: errorData.actionable, // action that can be taken
    actionType: errorData.actionType,
    errorMsg: errorData.message,
    errorExtraInfo: errorData.extraInfo, // dynamic data
    URLpath: errorData.url,
  };
};
